import React, { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { api, apiError } from "@/lib/api";

const FIELDS = [
  ["min_bet", "Minimum participation (Rs)", "number"], ["max_bet", "Maximum participation (Rs)", "number"],
  ["reward_percent", "Virtual reward (%)", "number"], ["start_date", "Available from", "date"],
  ["end_date", "Available until", "date"], ["open_time", "Daily open (PKT)", "time"], ["close_time", "Daily close (PKT)", "time"],
];
const toList = (s) => String(s).split(",").map((x) => parseInt(x.trim(), 10)).filter((n) => n > 0);

export const CupsConfigForm = ({ cfg, onSaved }) => {
  const [f, setF] = useState({ ...cfg, review_rounds: cfg.review_rounds.join(", "), win_milestones: cfg.win_milestones.join(", ") });
  const save = async () => {
    const body = { enabled: f.enabled, review_rounds: toList(f.review_rounds), win_milestones: toList(f.win_milestones) };
    FIELDS.forEach(([k, , type]) => { body[k] = type === "number" ? Number(f[k]) : (f[k] || ""); });
    try { await api.put("/admin/cups/config", body); toast.success("Three Cups settings saved"); onSaved(); }
    catch (err) { toast.error(apiError(err.response?.data?.detail)); }
  };
  return (
    <div className="ec-card p-6" data-testid="cups-config-form">
      <div className="flex items-center justify-between mb-5">
        <Label>Game Enabled</Label>
        <Switch checked={!!f.enabled} onCheckedChange={(v) => setF({ ...f, enabled: v })} data-testid="cups-enabled-switch" />
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        {FIELDS.map(([k, label, type]) => (
          <div key={k}><Label className="text-xs">{label}</Label>
            <Input type={type} step="any" value={f[k] ?? ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="mt-1" data-testid={`cups-cfg-${k}`} /></div>
        ))}
        <div><Label className="text-xs">Review after N rounds (comma list)</Label>
          <Input value={f.review_rounds} onChange={(e) => setF({ ...f, review_rounds: e.target.value })} className="mt-1" data-testid="cups-cfg-review_rounds" /></div>
        <div><Label className="text-xs">Win milestones (comma list)</Label>
          <Input value={f.win_milestones} onChange={(e) => setF({ ...f, win_milestones: e.target.value })} className="mt-1" data-testid="cups-cfg-win_milestones" /></div>
      </div>
      <p className="text-xs text-gray-500 mt-3">Open = Close means open all day. Thresholds are for reporting only and never affect results.</p>
      <Button onClick={save} className="mt-4 w-full bg-orange-600 hover:bg-orange-500 btn-glow font-semibold" data-testid="cups-save-config">Save Settings</Button>
    </div>
  );
};
